import * as angular from "angular";
import * as _ from "lodash";
import { HouseService } from "../services/house.service";
import { HouseOccupant } from "./house-occupant.model";

export class House {
    private $q: any;
    private resource: HouseService;

    public id?: string;
    public hid?: string;
    public hlastmodifieddatetime?: Date | string;
    public hunit?: string;
    public hfloor?: string;
    public hname?: string;
    public hnumber?: string;
    public haddress?: string;
    public hcity?: string;
    public hstate?: string;
    public hprecinct?: string;
    public hprecint?: string;
    public hzipcode?: string;
    public hdirections?: string;
    public notes: any;
    public hsource: string;

    public relevance?: any;
    public hlatitude?: any;
    public hlongitude?: any;
    public occupants?: Array<HouseOccupant>;
    public hlocationtype?: any;
    public cssid?: any;
    public cssname?: any;
    public csreception?: any;
    public cscreationdatetime?: any;
    public cstype?: string;
    public csscolor?: any;
    public user?: any;
    public activities?: any;
    public hofname?: string;
    public holname?: string;
    public displayValue?: any;
    public options?: any;
    public hoid?: any;
    public bid?: any;
    public checked?: boolean;

    public dwelling_type?: string;
    public homeowner?: string;
    public square_footage?: number;
    public year_built?: number;
    public purchase_price?: number;
    public purchase_year?: number;
    public net_worth?: number;

    constructor($q: any, HouseService: HouseService, data?: object) {
        this.$q = $q;
        this.resource = HouseService;

        if (data) {
            this.setData(data);
        }
    }

    separateNumber(house: House): void {
        let matches = house.haddress.match("([0-9]+)\\s(.+)");
        matches === null ? (matches = ["", "", house.haddress]) : matches;
        matches[1] === undefined ? (matches[1] = "") : matches[1];
        if (!house.hnumber) {
            house.hnumber = matches[1];
            house.haddress = matches[2];
        }
    }

    clean(house: House): void {
        for (let key in house) {
            if (house.hasOwnProperty(key)) {
                if (house[key] && typeof house[key] === "string") {
                    house[key] = house[key].trim();
                    if (house[key] === "") house[key] = null;
                }
            }
        }
    }

    isProspectorHouse(): boolean {
        return this.hsource == "Prospector";
    }

    getID(): string {
        return this.hid;
    }

    setData(data: object): void {
        _.merge(this, data);
        this.clean(this);
    }

    update(): Promise<any> {
        const deferred = this.$q.defer();
        this.resource.update(this).then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    angular.extend(this, json.data);
                    deferred.resolve(this);
                } else {
                    deferred.reject(json);
                }
            },
            (response: object) => {
                deferred.reject(response);
            }
        );
        return deferred.promise;
    }

    address(): string {
        let line = "";
        if (this.hunit) line += this.hunit + ", ";
        if (this.hfloor) line += this.hfloor + ", ";
        if (this.hname) line += this.hname + ", ";
        if (this.hnumber) line += this.hnumber + ", ";
        if (this.haddress) line += this.haddress;
        return line;
    }

    formatAddressLine1(): string {
        let line = "";
        if (this.hunit) line += this.hunit + ", ";
        if (this.hfloor) line += this.hfloor + ", ";
        if (this.hname) line += this.hname + ", ";
        if (this.hnumber) line += this.hnumber + " ";
        if (this.haddress) line += this.haddress;
        return line;
    }

    formatAddressLine2(): string {
        let line = "";
        if (this.hcity) line += this.hcity + ", ";
        if (this.hstate) line += this.hstate + ", ";
        if (this.hprecinct) line += this.hprecinct + ", ";
        if (this.hzipcode) line += this.hzipcode;
        return line;
    }
}
